var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1508_1928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 2.40992V14.0809C22.9739 14.1723 22.9455 14.2637 22.9222 14.3577C22.6175 15.611 21.6205 16.4282 20.3446 16.4386C18.503 16.4517 16.6589 16.4386 14.8174 16.4491C14.6934 16.4491 14.5384 16.5144 14.448 16.6005C13.8075 17.2272 13.1824 17.8694 12.5522 18.5065C11.9014 19.1619 11.1007 19.1645 10.4498 18.5091C9.82993 17.8851 9.20747 17.2611 8.59276 16.6292C8.46104 16.4935 8.32931 16.4386 8.14077 16.4386C6.29147 16.4439 4.43959 16.4543 2.59029 16.436C1.15166 16.4204 0.0074731 15.2402 0.00489028 13.7859C-0.00285817 10.0757 -0.000275352 6.36815 0.00489028 2.66057C0.00489028 2.18277 0.1237 1.72846 0.371651 1.32115C0.898546 0.456919 1.66823 0 2.68069 0C8.55919 0 14.4403 0 20.3188 0C20.3498 0 20.3782 0 20.4092 0C21.6205 0.0365535 22.6149 0.848564 22.9067 2.03916C22.9377 2.16188 22.9687 2.2846 22.9997 2.40992ZM11.4752 4.63708C11.3047 4.49086 11.1446 4.35248 10.9845 4.21932C10.2845 3.63969 9.49933 3.37076 8.58501 3.53525C7.35301 3.75457 6.35088 4.9295 6.31213 6.19321C6.27856 7.27415 6.60141 8.24804 7.14897 9.15666C8.10977 10.7493 9.50191 11.8773 11.0568 12.8251C11.359 13.0104 11.6766 12.9817 11.9737 12.799C13.2806 11.9948 14.4764 11.0548 15.4011 9.80679C16.1553 8.7859 16.677 7.66841 16.6718 6.36553C16.6667 5.2141 16.1398 4.34726 15.135 3.81462C14.1613 3.29765 13.1979 3.39687 12.2914 4.00522C12.0124 4.19321 11.7593 4.41775 11.4778 4.63708H11.4752Z",
    fill: "#F2705A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1508_1928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommended);
export default __webpack_public_path__ + "static/media/recommended.262d341df608c5a8105f557676f98035.svg";
export { ForwardRef as ReactComponent };